import api from '@/services/utils/apiInstance'

class SerialNumberService {
  async getProductTypeBySubCategory(subCategoryId) {
    let encodedSubCategoryId = encodeURIComponent(subCategoryId)

    const response = await api.get(
      '/distributor/serial-number/by-sub-category-id/' + encodedSubCategoryId
    )
    return response.data
  }
}

export default new SerialNumberService()
